import { Link } from "react-router-dom";
import { Check, ArrowRight, ShieldCheck, Zap, Heart } from "lucide-react";
import AppointmentForm from "../components/AppointmentForm";
import FAQ from "../components/FAQ";
import TestimonialsSection from "../components/TestimonialsSection";
import CTASection from "../components/CTASection";

export default function Implantes() {
  const faqs = [
    { q: "¿Duele la colocación de un implante dental?", a: "No. La intervención se realiza bajo anestesia local y es totalmente indolora. Nuestros pacientes suelen sorprenderse de lo rápido y sencillo que resulta." },
    { q: "¿Cuánto cuesta un implante dental en Calafell?", a: "Cada caso es diferente. Ofrecemos la primera visita gratuita con diagnóstico TAC 3D y presupuesto cerrado, sin sorpresas. Contamos con financiación hasta 60 meses sin intereses." },
    { q: "¿Cuánto dura un implante dental?", a: "Con cuidados adecuados, los implantes dentales modernos pueden durar décadas. Usamos implantes de marcas premium con garantía internacional." },
    { q: "¿Soy candidato a implantes si tengo poco hueso?", a: "Sí, en la mayoría de casos. Disponemos de técnicas de regeneración ósea e implantes especiales para pacientes con atrofia maxilar." },
  ];
  return (
    <div data-testid="implantes-page">
      <section className="py-20 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-1.5 mb-6">
                <span className="text-xs font-semibold text-teal-700 uppercase">Implantología · Calafell</span>
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
                Implantes dentales en <span className="underline-accent">Calafell</span>
              </h1>
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                Recupera la funcionalidad y estética de tu sonrisa con implantes dentales de última generación.
                Más de 40 años colocando implantes con éxito en Calafell Platja.
              </p>
              <Link to="/contacto" className="btn-primary" data-testid="implantes-cta-top">
                Primera visita + TAC gratis <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-slate-100">
              <h3 className="text-xl font-bold text-slate-900 mb-2">Reserva tu diagnóstico gratuito</h3>
              <p className="text-sm text-slate-600 mb-5">Incluye TAC 3D y plan de tratamiento</p>
              <AppointmentForm defaultService="Implantes dentales" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-max">
          <div className="max-w-3xl mb-14">
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">
              Ventajas de los implantes dentales
            </h2>
            <p className="text-lg text-slate-600">La solución definitiva para reemplazar piezas dentales perdidas.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: Heart, title: "Estética perfecta", desc: "Indistinguibles de dientes naturales." },
              { icon: Zap, title: "Función total", desc: "Come y habla con total normalidad." },
              { icon: ShieldCheck, title: "Duración para toda la vida", desc: "Con cuidados adecuados, décadas de uso." },
            ].map((item, i) => (
              <div key={i} className="bg-teal-50 rounded-3xl p-8" data-testid={`implante-advantage-${i}`}>
                <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center mb-5">
                  <item.icon className="w-5 h-5 text-teal-700" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-50">
        <div className="container-max">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">Nuestro proceso</h2>
          <p className="text-lg text-slate-600 mb-14 max-w-2xl">
            Un protocolo claro, transparente y sin sorpresas. Así es como tratamos cada caso.
          </p>
          <div className="grid md:grid-cols-4 gap-4">
            {[
              { n: "01", t: "Diagnóstico", d: "Primera visita gratuita con TAC 3D y escáner intraoral." },
              { n: "02", t: "Planificación", d: "Diseño digital del caso. Ves el resultado antes de empezar." },
              { n: "03", t: "Colocación", d: "Cirugía guiada e indolora bajo anestesia local." },
              { n: "04", t: "Corona final", d: "Colocación de la corona tras la osteointegración (2-4 meses)." },
            ].map((step, i) => (
              <div key={i} className="bg-white rounded-3xl p-6 border border-slate-200">
                <div className="text-5xl font-bold text-teal-200 mb-3">{step.n}</div>
                <h3 className="font-bold text-slate-900 mb-2">{step.t}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{step.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TestimonialsSection limit={3} />
      <FAQ items={faqs} title="Preguntas frecuentes sobre implantes" />
      <CTASection />
    </div>
  );
}
